//
//
//
//
//
//

export default {
  name: 'ChipComponent',
  props: {
    bindValue: {
      type: String,
      default: ''
    },
    chipClass: {
      type: String,
      default: 'chip'
    },
    withDismiss: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLink () {
      return this.$Search.getFilterUrl(this.bindValue, this.$Search.getAttributeValue(this.bindValue))
    }
  },
  methods: {
    async clearVal () {
      this.$Search.resetAttributeValue(this.bindValue)
      await new Promise((resolve, reject) => {
        this.$Search.search().finally(() => {
          resolve()
        })
      })
    }
  }
}
